import api from '@/api';

export default {
	state: {
		currentUser: null,
		isAuthenticated: false
	},
	mutations: {
		SET_CURRENT_USER (state, user) {
			state.currentUser = user;
		},
		SET_IS_AUTHENTICATED (state, value) {
			state.isAuthenticated = value;
		}
	},
	actions: {

		async getCurrentUser (context, uuid) {
			try {
				const response = await api.auth.getCurrentUser(uuid);
				context.commit('SET_CURRENT_USER', response.data);
				context.commit('SET_IS_AUTHENTICATED', true);
			} catch (error) {
				console.log(error);
				throw error;
			}
		},

		removeCurrentUser (context) {
			context.commit('SET_CURRENT_USER', null);
			context.commit('SET_IS_AUTHENTICATED', false);
		}
	},
	getters: {
		userSchoolId: (state) => {
			if (state.currentUser && state.currentUser.roles) {
				let role = state.currentUser.roles.find((role) => role.schoolId && role.schoolId !== 0);
				return role ? role.schoolId : 0;
			}
			else 0;
		}
	}
};



// WEBPACK FOOTER //
// ./src/store/session/index.js